import { honeyConsumptionContract } from "config";
import { BigNumber } from "ethers";
import { useContractRead } from "wagmi";

const useHoneyConsumed = (
  tokenId?: number | string | BigNumber
): [honeyConsumed: BigNumber | undefined, readHoneyConsumed: () => void] => {
  const [{ data: honeyConsumedData }, readHoneyConsumed] = useContractRead(
    {
      addressOrName: honeyConsumptionContract.address,
      contractInterface: honeyConsumptionContract.interface,
    },
    "honeyConsumed",
    {
      args: tokenId,
    }
  );

  return [honeyConsumedData as BigNumber | undefined, readHoneyConsumed];
};

export default useHoneyConsumed;
